import z from 'zod'

export const ApproveActionableSchema = z.object({
    type: z.literal('APPROVE'),
    credit: z.string(),
    debit: z.string(),
    amount: z.number(),
})